// Error codes specific to the tenancy module (companies/stores/locations/stations/memberships).
export const TENANCY_COMPANY_NOT_FOUND = 'TENANCY_COMPANY_NOT_FOUND';
export const TENANCY_COMPANY_ACCESS_DENIED = 'TENANCY_COMPANY_ACCESS_DENIED';
export const TENANCY_STORE_NOT_FOUND = 'TENANCY_STORE_NOT_FOUND';
export const TENANCY_LOCATION_NOT_FOUND = 'TENANCY_LOCATION_NOT_FOUND';
export const TENANCY_STATION_NOT_FOUND = 'TENANCY_STATION_NOT_FOUND';
export const TENANCY_STATION_DEVICE_CLAIM_NOT_FOUND = 'TENANCY_STATION_DEVICE_CLAIM_NOT_FOUND';
export const TENANCY_STATION_DEVICE_CLAIM_CONFLICT = 'TENANCY_STATION_DEVICE_CLAIM_CONFLICT';
export const TENANCY_STATION_RECOVERY_REASON_REQUIRED = 'TENANCY_STATION_RECOVERY_REASON_REQUIRED';
export const TENANCY_YARD_LOCATION_NOT_FOUND = 'TENANCY_YARD_LOCATION_NOT_FOUND';
export const TENANCY_YARD_LOCATION_INACTIVE = 'TENANCY_YARD_LOCATION_INACTIVE';
export const TENANCY_YARD_LOCATION_SCOPE_MISMATCH = 'TENANCY_YARD_LOCATION_SCOPE_MISMATCH';
export const TENANCY_MEMBERSHIP_NOT_FOUND = 'TENANCY_MEMBERSHIP_NOT_FOUND';
export const TENANCY_COMPANY_SUSPENDED = 'TENANCY_COMPANY_SUSPENDED';
export const TENANCY_INVALID_TENANCY_HIERARCHY = 'TENANCY_INVALID_TENANCY_HIERARCHY';
export const TENANCY_INVALID_STATUS = 'TENANCY_INVALID_STATUS';
export const TENANCY_DUPLICATE_CODE = 'TENANCY_DUPLICATE_CODE';
export const TENANCY_DUPLICATE_NAME = 'TENANCY_DUPLICATE_NAME';
export const TENANCY_MEMBERSHIP_ALREADY_EXISTS = 'TENANCY_MEMBERSHIP_ALREADY_EXISTS';
export const TENANCY_PLAN_NOT_FOUND = 'TENANCY_PLAN_NOT_FOUND';

export const tenancyErrorCodes = [
  TENANCY_COMPANY_NOT_FOUND,
  TENANCY_COMPANY_ACCESS_DENIED,
  TENANCY_STORE_NOT_FOUND,
  TENANCY_LOCATION_NOT_FOUND,
  TENANCY_STATION_NOT_FOUND,
  TENANCY_STATION_DEVICE_CLAIM_NOT_FOUND,
  TENANCY_STATION_DEVICE_CLAIM_CONFLICT,
  TENANCY_STATION_RECOVERY_REASON_REQUIRED,
  TENANCY_YARD_LOCATION_NOT_FOUND,
  TENANCY_YARD_LOCATION_INACTIVE,
  TENANCY_YARD_LOCATION_SCOPE_MISMATCH,
  TENANCY_MEMBERSHIP_NOT_FOUND,
  TENANCY_COMPANY_SUSPENDED,
  TENANCY_INVALID_TENANCY_HIERARCHY,
  TENANCY_INVALID_STATUS,
  TENANCY_DUPLICATE_CODE,
  TENANCY_DUPLICATE_NAME,
  TENANCY_MEMBERSHIP_ALREADY_EXISTS,
  TENANCY_PLAN_NOT_FOUND,
] as const;

export type TenancyErrorCode = (typeof tenancyErrorCodes)[number];
